var _rect, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCloseDrawer(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 34,
    viewBox: "0 0 33 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32.0343,
    height: 34,
    rx: 4,
    fill: "#818181"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.46991 24.959C9.25078 24.959 9.03165 24.8697 8.8642 24.6914C8.52964 24.3348 8.52964 23.7559 8.8642 23.3989L21.1132 10.3302C21.4478 9.97326 21.9897 9.97326 22.3246 10.3302C22.6592 10.6868 22.6592 11.2658 22.3246 11.6227L10.0756 24.6914C9.90818 24.8701 9.68905 24.959 9.46991 24.959Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7189 24.959C21.4998 24.959 21.2807 24.8697 21.1132 24.6914L8.8642 11.6227C8.52964 11.2661 8.52964 10.6872 8.8642 10.3302C9.19875 9.97326 9.74073 9.97326 10.0756 10.3302L22.3246 23.3989C22.6592 23.7555 22.6592 24.3345 22.3246 24.6914C22.1572 24.8701 21.9381 24.959 21.7189 24.959Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseDrawer);
export default __webpack_public_path__ + "static/media/closeDrawer.1531eb96d0a694a253e43abff818c7bb.svg";
export { ForwardRef as ReactComponent };